import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

import { getIsFetchingOrNotStarted } from '@/reducers/fetch'
import { getCurrentUser } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { selectCatchUpBookkeepingIsCompleteForUser } from '@/components/CatchUpBookkeepingStatus/catchUpBookkeepingStatus.selector'
import { FETCH_USER_CATCH_UP_BOOKKEEPING_STATUS } from '@/components/CatchUpBookkeepingStatus/catchUpBookkeepingStatus.slice'

import { Icon, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

// TODO: Migrate to V2
import { Loader } from 'semantic-ui-react'

const completeIcon = <Icon icon={solid('circle-check')} />
const refreshIcon = <Icon icon={solid('refresh')} />

export const CatchUpBookkeepingStatus = () => {
  const currentUser = useReselector(getCurrentUser)
  const catchUpBKComplete = useReselector(
    selectCatchUpBookkeepingIsCompleteForUser,
    currentUser?.id
  )
  const fetchingStatus = useReselector(
    getIsFetchingOrNotStarted,
    FETCH_USER_CATCH_UP_BOOKKEEPING_STATUS
  )

  return (
    <div
      className={`rounded-full flex items-center gap-4 py-3 px-6 mt-4 w-fit ${
        catchUpBKComplete ? 'bg-priority-25' : 'bg-priority-0'
      }`}
    >
      {fetchingStatus ? (
        <div style={{ height: '4em', padding: '1em' }}>
          <Loader active inline />
        </div>
      ) : (
        <>
          {catchUpBKComplete ? completeIcon : refreshIcon}
          <div>
            <Text variant={TypographyStyles.BODY_SM}>
              {catchUpBKComplete
                ? 'Your catch-up bookkeeping is complete!'
                : 'Catch-up bookkeeping in progress'}
            </Text>
            <Text variant={TypographyStyles.BODY_XS}>
              {catchUpBKComplete
                ? 'Complete the rest of your onboarding below to get the most out of Heard.'
                : 'We’ll let you know if we need to you to clarify something.'}
            </Text>
          </div>
        </>
      )}
    </div>
  )
}
